import React, { useEffect } from 'react';
import { parseISO, differenceInDays, subDays } from 'date-fns';
import { format } from 'date-fns/esm';
import { SITE_ADDRESS_PEMBELAJARAN } from '../../App/common/data/siteConfig';
import Bullhorn from '../../App/common/icons/Bullhorn';
import TextSearch from '../../App/common/icons/TextSearch';
import Icon from '@mdi/react';
import { mdiAttachment } from '@mdi/js';
import {
  checkMedia,
  formatNameLength,
} from '../../App/common/helpers/othersHelpers';

export default function AnnouncementTimeLine(props) {
  const {
    auth,
    history,
    openModal,
    announcements,
    getAnnouncements,
    handleLink,
    downloadFile,
  } = props;

  useEffect(() => {
    getAnnouncements({
      auth,
      history,
      tingkat: auth?.active_tingkat,
      kelas: auth?.active_kelas,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BodyCardHeader handleLink={handleLink}>
      <AnnouncementContent
        auth={auth}
        history={history}
        announcements={announcements}
        openModal={openModal}
        downloadFile={downloadFile}
      />
    </BodyCardHeader>
  );
}

function BodyCardHeader({ children, handleLink }) {
  return (
    <div className='column'>
      <div className='card'>
        <header
          className='card-header has-background-white has-text-primary-dark hand-pointer'
          onClick={() => handleLink('/pengumuman')}
        >
          <div className='custom-card-flex is-size-6' style={{ width: '100%' }}>
            <p>
              <span className='flex justify-start align-center'>
                <Bullhorn size={18} color={'#00947e'} />
                <span className='ml-1'>Pengumuman</span>
              </span>
            </p>
          </div>
        </header>
        <div className='card-content fadein pr-2'>
          <div className='overflow-auto pb-1 px-3' style={{ maxHeight: 300 }}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

function AnnouncementContent({
  auth,
  history,
  announcements,
  downloadFile,
  openModal,
}) {
  const handleAttachement = (id, file) => {
    let fileData = file && JSON.parse(file);
    let filelink = fileData && fileData.filelink;
    function checkImage(url) {
      return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url);
    }
    let isImage = checkImage(filelink);
    if (isImage) {
      openModal('PopUpImageModal', {
        data: SITE_ADDRESS_PEMBELAJARAN + filelink,
      });
    } else {
      downloadFile(auth, history, id, fileData);
    }
  };

  function subtractDays(dateString, daysToSubtract) {
    try {
      const date = parseISO(dateString);
      const subtractedDate = subDays(date, daysToSubtract);
      return format(subtractedDate, 'd MMM');
    } catch (error) {
      return 'Invalid date format';
    }
  }

  return (
    <>
      {announcements?.[0] && (
        <div className='timeline'>
          {announcements?.[0] && (
            <header className='timeline-header'>
              <span className='tag is-link'>
                {announcements?.[0]?.date &&
                  format(parseISO(announcements[0].date), 'MMM yyyy')}
              </span>
            </header>
          )}
          {announcements?.[0] &&
            announcements.map((item, index) => {
              let filename = item.file && JSON.parse(item.file).filename;
              return (
                <div className='timeline-item ck-custom' key={index}>
                  <div className='timeline-marker'></div>
                  <div className='timeline-content'>
                    <p
                      className={`heading${
                        differenceInDays(
                          item && item.date && parseISO(item.date),
                          new Date(),
                        ) >= 0
                          ? ' has-text-info'
                          : ''
                      }`}
                    >
                      {item?.date &&
                        item?.day &&
                        subtractDays(item.date, item.day)}{' '}
                      - {item.title}
                    </p>
                    <div>
                      <div
                        className='ck-content'
                        style={{ fontSize: 13 }}
                        dangerouslySetInnerHTML={{
                          __html:
                            item?.description &&
                            checkMedia({ string: item?.description }),
                        }}
                      ></div>
                      {item.file && (
                        <div>
                          <span
                            className='mt-1 mr-2 hand-pointer tag is-info is-rounded flex align-center'
                            onClick={() =>
                              handleAttachement(item.id, item.file)
                            }
                          >
                            <span className='mr-1 icon is-small'>
                              <Icon path={mdiAttachment} size={1} />
                            </span>
                            <span>
                              {formatNameLength({
                                string: filename,
                                length: 25,
                              })}
                            </span>
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      )}
      {!announcements?.[0] && (
        <div style={{ height: 180 }}>
          <span className='flex flex-column align-center'>
            <span
              className='flex flex-column align-center'
              style={{
                border: '1px solid #e6e6e6',
                borderRadius: 10,
                width: 108,
                padding: 10,
                margin: 16,
                marginTop: 28,
              }}
            >
              <TextSearch size={72} color={'#cdcdcd'} />
              <span style={{ color: '#929292' }}>No data</span>
            </span>
          </span>
        </div>
      )}
    </>
  );
}
